module.exports = __webpack_public_path__ + "static/home-page-cover-9fecc44bebbd2448e6709656f1ea52f5.jpg";